import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomDatePicker } from '../../components/CustomDatePicker';
import { usePrevious } from '../../custom-hooks';
import { EMPTY_INPUT_MASKS, getDateFormat, processInputValue } from '../../utils/dateUtils';
import { updateControlProperty } from '../actions/report-designer.actions';
import { REPORT_DESIGNER_DATE_FORMAT } from '../constants/report-designer.constants';
import {
  getControlProperty,
  getHasValidationErrorByIdAndProp,
} from '../selectors/report-designer.selectors';

const DateInput = ({ id, controlType, className }) => {
  const dispatch = useDispatch();

  const startDate = useSelector((state) => getControlProperty(state, { id, prop: controlType }));
  const startDateValidationError = useSelector((state) =>
    getHasValidationErrorByIdAndProp(state, { id, prop: controlType })
  );

  const [newValue, setValue] = useState(startDate);
  const [inputValue, setInputValue] = useState('');
  const [hasInputValueChanged, setInputValueChanged] = useState(false);
  const prevDateValue = usePrevious(startDate);

  // update value in store when value is changed from Calender modal picker
  const handleCalenderValueChange = (date) => {
    if (moment.isMoment(date)) {
      const formattedDate = date.format(REPORT_DESIGNER_DATE_FORMAT);
      dispatch(updateControlProperty(id, controlType, formattedDate));

      setInputValueChanged(false);
      return;
    }
  };

  // update value in store when value is changed manually
  const submitInputValue = () => {
    const dateFormat = getDateFormat(newValue);
    const newInputDate = processInputValue(newValue, dateFormat);

    if (inputValue !== newInputDate && hasInputValueChanged) {
      dispatch(updateControlProperty(id, controlType, inputValue));
    }
  };

  const handleInputChange = (newInputValue) => {
    if (newInputValue !== inputValue) {
      EMPTY_INPUT_MASKS.includes(newInputValue) ? setInputValue('') : setInputValue(newInputValue);
      setInputValueChanged(true);
    }
  };

  const handleNewInputValue = (value) => {
    const dateFormat = getDateFormat(value);
    const newInputDate = processInputValue(value, dateFormat);

    if (prevDateValue !== value || newInputDate !== inputValue) {
      setInputValue(newInputDate);
    }
  };

  // Update inner state when `value` is changed from outside.
  useEffect(() => {
    setValue(startDate);
    handleNewInputValue(startDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate]);

  return (
    <CustomDatePicker
      id={id}
      error={startDateValidationError}
      storeValue={newValue}
      onChangeHandler={handleCalenderValueChange}
      onBlurHandler={submitInputValue}
      inputValue={inputValue}
      onInputChangeHandler={handleInputChange}
      className={className}
    />
  );
};

export default DateInput;
